import { Ref, RefObject, useEffect, useRef } from 'react';

export function useShareForwardedRef<T>(forwardedRef: Ref<T>): RefObject<T> {
  const innerRef = useRef<T>(null);

  useEffect(() => {
    if (!forwardedRef) {
      return;
    }

    if (typeof forwardedRef === 'function') {
      forwardedRef(innerRef.current);
    } else {
      // @ts-ignore
      forwardedRef.current = innerRef.current; // eslint-disable-line no-param-reassign
    }
  }, [innerRef, forwardedRef]);

  return innerRef;
}
